import {
  FETCH_COIN_TASKS_REQUEST,
  FETCH_COIN_TASKS_SUCCESS,
  FETCH_COIN_TASKS_FAILURE,
} from '../types/coinTaskTypes';

const initialState = {
  items: [],
  loading: false,
  error: null,
  total: 0,
  count: 0,
};

const coinTaskReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COIN_TASKS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_COIN_TASKS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.items || [],
        total: action.payload.objects?.total || 0,
        count: action.payload.objects?.count || 0,
      };
    case FETCH_COIN_TASKS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default coinTaskReducer;
